import React from "react";

import type {
  Paging,
  Place,
} from "../../../../application/domain/proc-management";
import { Title } from "../../../atoms/proc-management/place-list";
import { MainMenu } from "../../../molecules/proc-management/place-list";
import PlacesTable from "./places-table";

type Props = {
  places: Place[];
  orgId: string;
  paging: Paging;
  onRowClick: (props: { orgId: string; placeId: string }) => void;
  onPageClick: (props: { orgId: string; page: number }) => void;
  isServiceProviderAccount?: boolean;
};

export const Content: React.FC<Props> = ({
  places,
  orgId,
  paging,
  onRowClick,
  onPageClick,
  isServiceProviderAccount = false,
}) => {
  return (
    <>
      <Title />
      <hr className="my-3" />
      <MainMenu
        orgId={orgId}
        isServiceProviderAccount={isServiceProviderAccount}
      />
      <PlacesTable
        places={places}
        orgId={orgId}
        paging={paging}
        onRowClick={onRowClick}
        onPageClick={onPageClick}
      />
    </>
  );
};

export default Content;
